import { TIME_FILTER_OPTIONS } from "../../constants";

export const MOMENT_GRANULARITIES = Object.freeze({
  [TIME_FILTER_OPTIONS.year.id]: "month",
  [TIME_FILTER_OPTIONS.month.id]: "week",
  [TIME_FILTER_OPTIONS.last_week.id]: "day",
} as const);
